/* eslint-disable */
import {
  curry, invoker, propSatisfies, when,
} from 'ramda';
import { fn } from '@555platform/utility-belt.js';

const methodDefined = propSatisfies(fn.isFunction);

const makeLean = when(methodDefined('lean'), invoker(0, 'lean'));

export const query = curry((createModel, method) => async (...args) => {
  const Model = createModel();

  if (!methodDefined(method, Model)) throw new Error(`No such method ${method} on model ${Model}`);

  const operation = Model[method].bind(Model)(...args);
  const result = await makeLean(operation);

  return result;
});

export default {
  query,
};
